"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.BootstrapButton = void 0;
const composition_api_1 = require("@vue/composition-api");
const _abstract_1 = require("../../_abstract");
const Button_hooks_1 = require("./Button.hooks");
const Button_config_1 = require("./Button.config");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.BootstrapButton = composition_api_1.defineComponent({
    name: 'BootstrapButton',
    props: Button_hooks_1.bootstrapButtonProps,
    setup(props, { emit }) {
        const { size, theme } = composition_api_1.toRefs(props);
        const { onClick, sizeClass, themeClass } = _abstract_1.useButton(emit, size, Button_config_1.bootstrapButtonSizeRegistry, theme, Button_config_1.bootstrapButtonThemeRegistry);
        return { onClick, sizeClass, themeClass };
    },
    template: `
    <button v-bind="{ disabled }" :class="['btn', sizeClass, themeClass]" @click="onClick">
      <slot />
    </button>
  `
});
//# sourceMappingURL=Button.js.map